// React
import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

// User Actions
import { updateProfile } from "../../actions/userActions";
import { listYears } from "../../actions/yearActions";
import { listWeeks } from "../../actions/weekActions";
import { listDays } from "../../actions/dayActions";

// Internal Components
import Header from "../../components/layouts/Header/Header";
import TestFooter from "../../components/layouts/Footer/TestFooter";
import FAQ from "../../components/ui/FAQ/FAQ";

// Stylesheet
import "./profile_menu.css";
import SEO from "../../components/seo/SEO";

export default function ProfileFAQScreen({ history }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const yearList = useSelector((state) => state.yearList);
  const { years } = yearList;

  const weekList = useSelector((state) => state.weekList);
  const { weeks } = weekList;

  const dayList = useSelector((state) => state.dayList);
  const { days } = dayList;

  useEffect(() => {
    dispatch(listYears());
  }, [dispatch, userInfo, history]);

  useEffect(() => {
    dispatch(listWeeks());
  }, [dispatch, userInfo, history]);

  useEffect(() => {
    dispatch(listDays());
  }, [dispatch, userInfo, history]);

  const [pageLoading, setPageLoading] = useState(true);

  const loadingTimeout = () => {
    setTimeout(() => {
      setPageLoading(false);
    }, 5000);
  };

  useEffect(() => {
    loadingTimeout();
  });

  return (
    <>
      <SEO
        title="Frequently Asked Questions"
        description="Here are the frequently asked questions about NoWastedDays"
        canonicalUrl={"https://nowasteddays.io/my-account/faqs"}
      />
      <main className="profile__menu--screen">
        <FAQ />
      </main>
    </>
  );
}
